import { EventListApiInterface } from 'modules/calendar/events/types/new-event-interface'
import { squareBracketsToDots } from 'modules/calendar/utils/square-brackets-to-dots'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string'
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import { EVENTS_API } from '../api/events-api'
import { EventFilterInterface } from '../types/calendar-filter-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

interface UseEventInterface extends SwrPaginationInterface {
  filter: EventFilterInterface
}

export function useEvents({ limit, pagination, filter }: UseEventInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, EventListApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: events, mutate } = useControlledSwr(() => {
    if (user) {
      return [
        `${EVENTS_API}/list?${squareBracketsToDots(
          getPaginationAndFilterQueryString({
            limit,
            pagination,
            filter,
          }),
        )}`,
        RequestModuleEnum.Calendar,
      ]
    }
  }, fetcher)

  const { data: counter } = useControlledSwr<CountInterface>(() => {
    if (user) {
      return [
        `${EVENTS_API}/count?pagination.limit.${squareBracketsToDots(
          getFilterQueryString({ filter }),
        )}`,
        RequestModuleEnum.Calendar,
      ]
    }
    return null
  }, baseFetcher)

  return { events, mutate, counter }
}
